<template>
  <div id="app">
    <router-view clas="main"> </router-view>
    <login-dialog />
  </div>
</template>

<script>
import LoginDialog from '@/components/LoginDialog'
export default {
  name: 'app',
  components: { LoginDialog }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "assets/css/style.scss";


#app {
  height: 100%;

}


.van-nav-bar {
  background-color: transparent;
  position: absolute;
  z-index: 100;
  height: 47px;
}

.fixed {
  position: fixed;
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
}



.van-icon {
  font-size: 18px;
}

.ellipsis1 {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

div {
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .el-message-box {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 80vw !important;
    /* 设置一个合适的宽度 */
    max-width: 80vw !important;
    /* 防止弹窗过宽 */
    margin: 0 !important;
    /* 移除默认的 margin */
    border-radius: 8px !important;
    /* 可选：调整圆角 */
  }

  /* 可选：调整弹窗内容在移动端的样式 */
  .el-message-box__content {
    font-size: 14px;
    /* 调整字体大小 */
  }

  /* 可选：调整按钮组在移动端的样式 */
  .el-message-box__btns {
    text-align: center;
    /* 按钮居中 */
  }

  .el-message-box__btns button {
    flex: 1;
    /* 按钮平均分配宽度 */
    margin: 0 5px;
    /* 添加一些间距 */
  }
}

.subject-type-blue {
  color: #1890ff !important;
  /* 蓝色样式 */
  font-weight: bold;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .info-confirm-dialog .el-dialog {
    width: 95% !important;
    border-radius: 8px;
  }


}
</style>
